import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Dropdown } from "react-bootstrap";
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

import {
    deleteAccountWebHookSubscriptionAsync, getAccountWebHookByAccountWebHookSubscriptionIdAsync, getSystemWebHookEventTypesAsync,
    checkedListState, unCheckedListState, checkedAllState, unCheckedAllState, getAccountWebHookAsync, updatePagination, updateSearchPagination,
    getAccountWebHookSubscriptionsForApiByAccountIdAsync, updateIsDisabledAsync, updateSorting
} from "./WebHookSlice";
import { Link } from "react-router-dom";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import '../../../common/css/timeLive.css'

const itemClass = 'ms-1 ms-lg-0';
export const WebHookItem = (props: any) => {

    const { WebHookList, t, onopenModal, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { currentPage, pageSize, start, totalItems, search, sortOrder, sortColumn, recordsFiltered, isLoading } = useAppSelector((state) => state.webHook);
    const [sortConfig, setSortConfig] = useState({
        columnIndex: 1,
        direction: 'asc'
    });

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedListState(rowId))
        } else {
            dispatch(unCheckedListState(rowId))
        }
    };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
            ShowSwalWithConfirmation(`All records selected on this page. Do you want to select all ${totalItems} records?`, "", `Yes, select all ${totalItems} records!`)
                .then((result) => {
                    if (result) {
                        dispatch(getAccountWebHookSubscriptionsForApiByAccountIdAsync());
                    }
                })
                .catch((error) => {
                });

        } else {
            dispatch(unCheckedAllState());
        }
    };
    const onEditClick = (AccountWebhookSubscriptionID: number) => {
        dispatch(getSystemWebHookEventTypesAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                dispatch(getAccountWebHookByAccountWebHookSubscriptionIdAsync(AccountWebhookSubscriptionID))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        onopenModal();
                    })
                    .catch((rejectedValueOrSerializedError) => {
                    })
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };

    const onDeleteClick = (AccountWebhookSubscriptionID: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountWebHookSubscriptionAsync(AccountWebhookSubscriptionID))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if (originalPromiseResult !== null) {
                                isGuid(originalPromiseResult.id) ?
                                    ShowToast("WebHook Delete Successfully", 'Success', "success", "toast-top-right") :
                                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                            else {
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    // const handleSort = (columnIndex: number) => {
    //     let direction = 'asc';
    //     if (sortConfig.columnIndex === columnIndex && sortConfig.direction === 'asc') {
    //         direction = 'desc';
    //     }
    //     setSortConfig({ columnIndex, direction });
    //     dispatch(getAccountWebHookAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, search: search }));
    // };

    const handleIsDisabledChange = (e: any, webhook: any) => {
        const { checked } = e.target;
        const foundIndex = WebHookList.findIndex((item: any) => item.AccountWebhookSubscriptionID === webhook.AccountWebhookSubscriptionID);
        if (foundIndex !== -1) {
            const foundItem = WebHookList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsActive = checked;
            const modifiedList = [...WebHookList.slice(0, foundIndex), updatedItem, ...WebHookList.slice(foundIndex + 1)];
            dispatch(updateIsDisabledAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
    }

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "startRec": 0,
            "pageSize": pageSize,
            "pageNo": 1
        }
        dispatch(updateSorting(objects));
    }

   
    return (
        <>

            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={WebHookList.every((item: any) => item.isSelected === 0) ? false :
                                            (WebHookList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        <th style={{ width: '10%' }}>
                            {/* {t('Active / Inactive')} */}
                            {getValueFromResource('Active / Inactive',dispatch, t)}
                           
                        </th>
                        {/* <th className='w-25'
                                                    // onMouseEnter={() => handleMouseEnter(7)}
                                                    // onMouseLeave={handleMouseLeave}
                                                    >{t("Name")}
                        </th> */}
                        <th style={{ width: '25%' }}>
                            {/* {t('Name')} */}
                            {getValueFromResource('Name',dispatch, t)}

                            {sortColumn === '1' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        {/* <th className='min-w-100' onClick={() => handleSort(2)}>
                            {t('Source Name')}
                            {sortConfig.columnIndex === 2 && (
                                <span>{sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}</span>
                            )}
                        </th> */}

                          <th style={{ width: '15%' }}>
                            {/* {t('Source Name')} */}
                            {getValueFromResource('Source Name',dispatch, t)}

                            {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        {/* <th className='min-w-100' onClick={() => handleSort(3)}>
                            {t('Event')}
                            {sortConfig.columnIndex === 3 && (
                                <span>{sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}</span>
                            )}
                        </th> */}
                        <th style={{ width: '15%' }}>
                            {/* {t('Event')} */}
                            {getValueFromResource('Event',dispatch, t)}

                            {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th className='min-w-100'>
                            {/* {t('Target URL')} */}
                            {getValueFromResource('Target URL',dispatch, t)}

                        </th>
                        {/* {IsEdit &&
                            <th className='min-w-100'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='min-w-100 text-center '></th>
                    </tr>
                </thead>
                <tbody>
                    {WebHookList.length === 0 && <tr><td colSpan={7}><p className='noDataFound mt-2'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}

                        </p></td></tr>}
                    {WebHookList.length > 0 && WebHookList.map((webHookDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={webHookDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, webHookDetail.AccountWebhookSubscriptionID) }}
                                        />
                                    </div>
                                </td>
                            }
                            {/* <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(webHookDetail.IsActive === false ? "Active" : "InActive"))}>
                                    {webHookDetail.IsActive === false ? "Active" : "InActive"}
                                </span>
                            </td> */}
                             <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(webHookDetail.IsActive === false ? "Active" : "InActive"))}>
                                    {webHookDetail.IsActive === false ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(webHookDetail.AccountWebhookSubscriptionID) : undefined}
                            >
                                <span className="d-block"> {webHookDetail.WebHookName}</span>
                            </td>
                            <td><span className="d-block">{webHookDetail.SystemWebHookSourceName}</span></td>
                            <td><span className="d-block">{webHookDetail.SystemWebhookEventTypeCaption}</span></td>
                            <td><span className="d-block">{webHookDetail.TargetURL}</span></td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsActive"
                                            //checked={webHookDetail.IsActive === 'Yes' ? true : false}
                                            checked={webHookDetail.IsActive}
                                            onChange={(e) => { handleIsDisabledChange(e, webHookDetail) }}
                                        />
                            } */}
                            <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                    <Dropdown
                                        style={{ marginLeft: 1 }}
                                        className={clsx('cursor-pointer symbol')}
                                        data-kt-menu-attach='parent'
                                        data-kt-menu-placement='bottom-end'
                                    >
                                        <Dropdown.Toggle
                                            variant="transparent"
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("More")}
                                            {getValueFromResource('More',dispatch, t)}
                                            data-tooltip-place="top"
                                        >
                                            <i className="bi bi-three-dots fs-7 " ></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                           className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => onEditClick(webHookDetail.AccountWebhookSubscriptionID)}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item className="menu-item me-lg-0 ">
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-receipt iconColor fs-6">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <Link to={`../webHookSenderLogs?WebHookSenderLogId=${webHookDetail.AccountWebhookSubscriptionID}`} >
                                                        <span style={{ fontSize: '13px', color: 'black' }}>
                                                            {/* {t('View Log')} */}
                                                            {getValueFromResource('View Log',dispatch, t)}

                                                            </span>
                                                    </Link>
                                                </Dropdown.Item>
                                            </div>

                                            {IsDelete && IsEdit &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(webHookDetail.AccountWebhookSubscriptionID) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </td>

                        </tr>
                    ))}

                </tbody>
            </table >

        </>
    )
}